import React, { useState, useEffect } from 'react';
import scrollImg from './scrollImg.png';

import './Scroll.css';

const Scroll = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    setVisible(scrolled > 150);
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisible);
    return () => window.removeEventListener('scroll', toggleVisible);
  }, []);

  return (
    <a href='#top' className={`scroll ${visible ? 'show' : 'hide'}`}>
      <img src={scrollImg} alt='' />
      <p className='scroll__text'>Back To Top</p>
    </a>
  );
};

export default Scroll;
